import { vSelect } from '@desislavsd/vue-select'
export default {
  vSelect
}



// WEBPACK FOOTER //
// ./src/app/auth/register/dweller/resources/components.js